document.addEventListener("DOMContentLoaded", () => {
  const scrollSections = document.querySelectorAll(".sf-scroll-text-section");

  scrollSections.forEach((section) => {
    const targets = section.querySelectorAll(".sf-scroll-text-target");

    // Phase 1: Split text into individually tracked word spans
    targets.forEach((target) => {
      const text = target.innerText.trim();
      const words = text.split(/\s+/);
      target.innerHTML = words
        .map(word => `<span class="sf-animate-word">${word}</span>`)
        .join(" ");
    });

    const allWords = section.querySelectorAll(".sf-animate-word");
    if (allWords.length === 0) return;

    // Phase 2: Scroll-driven fill calculation
    const calculateScrollFill = () => {
      const rect = section.getBoundingClientRect();
      const windowHeight = window.innerHeight;

      const startPoint = windowHeight * 0.85;
      const totalScrollable = rect.height + windowHeight * 0.5;
      const currentScrollPos = startPoint - rect.top;

      let overallProgress = currentScrollPos / totalScrollable;
      overallProgress = Math.max(0, Math.min(1, overallProgress));

      const totalWords = allWords.length;

      allWords.forEach((word, idx) => {
        const wordStart = idx / totalWords;
        const wordEnd = (idx + 1) / totalWords;

        let wordFill = (overallProgress - wordStart) / (wordEnd - wordStart);
        wordFill = Math.max(0, Math.min(1, wordFill)) * 100;

        word.style.setProperty("--progress", `${wordFill}%`);
      });
    };

    window.addEventListener("scroll", calculateScrollFill, { passive: true });
    window.addEventListener("resize", calculateScrollFill, { passive: true });

    calculateScrollFill();
  });
});